import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3ecbbf7c";
import script from "./List.vue?vue&type=script&lang=js";
export * from "./List.vue?vue&type=script&lang=js";
import style0 from "./List.vue?vue&type=style&index=0&id=3ecbbf7c&prod&lang=less";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;